'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentGiropayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3419 37.482V20.9469C11.3449 19.5717 12.6018 18.4588 14.1553 18.4563H43.4282V39.9726H14.1553C12.6018 39.9699 11.3449 38.8568 11.3419 37.482ZM70.1792 16.5969H14.1553C11.4411 16.5973 9.24252 18.5435 9.24159 20.9469V37.482C9.24252 39.8846 11.4411 41.831 14.1553 41.8318H70.1792C72.8932 41.831 75.0921 39.8846 75.093 37.482V20.9469C75.0921 18.5435 72.8932 16.5973 70.1792 16.5969Z",
          fill: "#0F3365"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M43.4282 18.4564H14.1553C12.6018 18.4588 11.3449 19.5717 11.3419 20.9469V37.482C11.3449 38.8569 12.6018 39.9699 14.1553 39.9726H43.4282V18.4564Z",
          fill: "#FFFFFE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M63.1668 34.7773C63.6724 34.8743 64.1773 34.9227 64.6964 34.9227C66.9501 34.9227 67.4822 33.3866 68.1782 31.8039L70.7869 25.9398H68.3289L66.8674 30.0501H66.8402L65.3106 25.9398H62.6624L65.5424 32.3835C65.3659 32.9396 64.9015 33.2541 64.3015 33.2541C63.9591 33.2541 63.6585 33.2185 63.3314 33.1209L63.1668 34.7773Z",
          fill: "#FFFFFE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M62.0629 32.2381C61.9539 31.7425 61.926 31.2472 61.926 30.7512V28.4059C61.926 26.4836 60.3559 25.7948 58.5397 25.7948C57.4878 25.7948 56.5731 25.9272 55.6993 26.2422L55.7397 27.7169C56.4232 27.3787 57.2149 27.2454 58.0065 27.2454C58.8945 27.2454 59.6186 27.4751 59.632 28.3338C59.318 28.285 58.8814 28.2483 58.4853 28.2483C57.1742 28.2483 54.812 28.4788 54.812 30.4009C54.812 31.7675 56.0682 32.3839 57.4748 32.3839C58.4853 32.3839 59.1681 32.0327 59.7276 31.2472H59.7543C59.7543 31.5736 59.7962 31.9005 59.8094 32.2381H62.0629ZM57.1057 30.2439C57.1057 29.6394 57.761 29.4097 58.5941 29.4097C58.963 29.4097 59.318 29.4338 59.632 29.4458C59.632 30.1829 59.0453 30.9335 58.1159 30.9335C57.5427 30.9335 57.1057 30.6785 57.1057 30.2439Z",
          fill: "#FFFFFE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M45.7611 34.7773H48.2187V31.3563H48.2461C48.7106 32.1059 49.6393 32.3835 50.4994 32.3835C52.6159 32.3835 53.7492 30.8361 53.7492 28.9741C53.7492 27.4512 52.6713 25.7948 50.7046 25.7948C49.5849 25.7948 48.5467 26.1938 48.0553 27.0763H48.0279V25.9398H45.7611V34.7773ZM51.2098 29.0227C51.2098 30.0264 50.6498 30.7152 49.7218 30.7152C48.9021 30.7152 48.2187 30.0264 48.2187 29.1072C48.2187 28.1645 48.8201 27.4631 49.7218 27.4631C50.6772 27.4631 51.2098 28.1881 51.2098 29.0227Z",
          fill: "#FFFFFE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M37.9339 32.3835C40.282 32.3835 42.071 31.1749 42.071 29.0954C42.071 27.0034 40.282 25.7948 37.9339 25.7948C35.5854 25.7948 33.7964 27.0034 33.7964 29.0954C33.7964 31.1749 35.5854 32.3835 37.9339 32.3835ZM37.9339 30.8602C36.8005 30.8602 36.3362 30.0264 36.3362 29.0954C36.3362 28.1523 36.8005 27.3181 37.9339 27.3181C39.0672 27.3181 39.5316 28.1523 39.5316 29.0954C39.5316 30.0264 39.0672 30.8602 37.9339 30.8602Z",
          fill: "#D8232A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M33.7018 25.8667C33.4558 25.8311 33.1555 25.7948 32.8691 25.7948C31.804 25.7948 31.1893 26.3025 30.7658 27.1H30.7388V25.9398H28.4993V32.2381H30.9571V29.579C30.9571 28.3455 31.5992 27.6079 32.7461 27.6079C33.0325 27.6079 33.3059 27.6079 33.5786 27.6802L33.7018 25.8667Z",
          fill: "#D8232A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M24.4001 32.2381H26.8579V25.9398H24.4001V32.2381ZM24.4001 24.912H26.8579V23.3162H24.4001V24.912Z",
          fill: "#D8232A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.7041 25.9398H20.4778V27.0759H20.4511C19.932 26.3025 19.0851 25.7948 18.0339 25.7948C15.8221 25.7948 14.825 27.1968 14.825 29.0709C14.825 30.9335 16.0403 32.2381 17.9932 32.2381C18.9763 32.2381 19.7955 31.9005 20.3822 31.1621H20.4099V31.5013C20.4099 32.7345 19.6456 33.3266 18.2252 33.3266C17.201 33.3266 16.5729 33.1334 15.8221 32.807L15.6989 34.5239C16.2726 34.7046 17.2422 34.9227 18.4163 34.9227C21.284 34.9227 22.7041 34.0881 22.7041 31.5013V25.9398ZM17.3649 29.0345C17.3649 28.1764 17.8428 27.4631 18.7578 27.4631C19.8636 27.4631 20.3281 28.2483 20.3281 28.9498C20.3281 29.9175 19.6314 30.5702 18.7578 30.5702C18.0204 30.5702 17.3649 30.0134 17.3649 29.0345Z",
          fill: "#D8232A"
        }
      )
    ]
  }
);
const VpPaymentGiropayAsset = forwardRef(PaymentGiropayAsset);

export { VpPaymentGiropayAsset as default };
